import { useState } from 'react'
import StockBillDetail from '../components/StockBillDetail'

export default function useShowStockBillDetail() {
  const [id, setId] = useState(null)
  const showDetail = re => {
    setId(re.no)
  }
  return {
    BillDetailNode: !!id && (
      <StockBillDetail id={id} onClose={() => setId(null)} />
    ),
    showDetail
  }
}
